import { faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { routeKeys } from 'ui/data/constants/keys';
import { labels } from 'ui/data/constants/labels';
import { alertMsgs } from 'ui/data/constants/messages';
import {
  validateLogin,
  getStoreState,
  setStoreState,
} from '@cogitate/ui-multi-utils';
import { persistConcurrencySession } from 'ui/utilities/concurrency';

import { storeKeys } from 'ui/data/constants/keys';
import nprogress from 'nprogress';
import { getMasterFromBlobAndDB } from 'ui/utilities/getMasterFromBlobAndDB';
import moment from 'moment';

export default function Login() {
  const router = useRouter();
  const { logout } = router.query;

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (_event) {
      window.history.pushState(null, document.title, window.location.href);
    });
    if (logout === '1') {
      toast.success(alertMsgs.Shared.LogOut);
    } else if (logout === '0') {
      toast.error(alertMsgs.Shared.SomethingWentWrong);
    }
    if (Object.keys(router.query).length) {
      router.replace({
        query: {},
      });
    }
  }, [logout]);

  const onFormSubmit = async (event) => {
    event.preventDefault();
    nprogress.start();
    var { username, password } = document.forms[0];
    var resp = await validateLogin(username.value, password.value);

    if (resp) {
      try {
        const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
        if (!loggedInUser?.decodedJWT) {
          throw new Error('createSessionID: missing decodedJWT');
        }
        const tabId = persistConcurrencySession(loggedInUser.decodedJWT);
        setStoreState(storeKeys.LoggedInUserReducer, {
          ...loggedInUser,
          decodedJWT: {
            ...loggedInUser.decodedJWT,
            TabId: tabId,
          },
        });
        await getMasterFromBlobAndDB();
        router.push(routeKeys.DashboardAccountHub.toLowerCase());
      } catch (err) {
        toast.error(
          err?.message?.includes('createSessionID')
            ? alertMsgs.Shared.SomethingWentWrong
            : alertMsgs.Login.FailedToFetchMasters
        );
      } finally {
        nprogress.done();
      }
    } else {
      toast.error(alertMsgs.Login.LoginFailed);
      nprogress.done();
    }
  };

  return (
    <>
      <Head>
        <title>{labels.Shared.Login.PageTitle}</title>
        <meta name="description" content="Developed By Team Cogitate" />
        <link
          rel="icon"
          href={`${process.env.NEXT_PUBLIC_CDN_IMAGE_PATH}/${process.env.NEXT_PUBLIC_AZURE_IMAGE_STYLE_STORAGE_ACCOUNT_NAME}/${process.env.NEXT_PUBLIC_CLIENT}/${process.env.NEXT_PUBLIC_ASSESTS_IMAGES}/favicon-embarkmh.png`}
        />
      </Head>
      <div className="wrapper bg-image">
        <div className="login-page-content">
          <div className="left-panel">
            <div className="left-panel-content">
              <div className="login-ca-logo">
                <img
                  src={`${process.env.NEXT_PUBLIC_CDN_IMAGE_PATH}/${process.env.NEXT_PUBLIC_AZURE_IMAGE_STYLE_STORAGE_ACCOUNT_NAME}/${process.env.NEXT_PUBLIC_CLIENT}/${process.env.NEXT_PUBLIC_ASSESTS_IMAGES}/logo.png`}
                  className="headerLogo"
                  alt="Embark MH"
                />
              </div>
              <div className="left-panel-child">
                <div className="login-ca-txt">
                  <span className="logoHead1">Personal</span>
                  <span className="logoHead2">Mobile Home</span>
                </div>
              </div>
            </div>
            <div className="company-rights">
              <p>
                {moment().format('YYYY')} @
                <a
                  href="https://www.cogitate.us"
                  rel="noreferrer"
                  target="_blank"
                >
                  Cogitate Technology Solutions
                </a>
                , All Rights Reserved{' '}
                <span style={{ color: 'red' }}>{`(BUILD NUMBER : ${
                  process.env.NEXT_PUBLIC_BUILD_NUMBER
                })`}</span>
              </p>
            </div>
          </div>
          <div className="right-panel">
            <form className="login-form" onSubmit={onFormSubmit}>
              <div className="form-header mb-3">Login</div>
              <div className="input-group">
                <span className="input-group-addon">
                  <FontAwesomeIcon icon={faUser} />
                </span>
                <input
                  type="text"
                  placeholder="Username"
                  name="username"
                  className="form-control"
                  required
                />
              </div>
              <div className="input-group">
                <span className="input-group-addon">
                  <FontAwesomeIcon icon={faLock} />
                </span>
                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  className="form-control"
                  required
                />
              </div>
              <input type="submit" className="buttonLogin" value="Sign In" />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

Login.layout = 'L1';
